<template>
  <div id="conteudo" class="px-4 pt-2">
    <slot />
  </div>
</template>

<script>
export default {
  name: "TempleteConteudoDialog"
}
</script>

<style scoped>
#conteudo {
  position: absolute;
  top: 80px;
  bottom: 80px;
  width: 100%;
}
</style>
